import { rewardsBalanceUrl, rewardsCertificateUrl, creditHealthUrl, statementsUrl, statementsEnrollmentUrl, accountActivityUrl, autoRegisterUrl, paymentQueryUrl, accountSummaryV2Url, creditAccountsUrl, autopayStatusUrl, autopayEligibilityUrl, payoffQuoteUrl, paymentMethodsUrl, settlementEligibilityUrl, accountFeaturesUrl, paymentEnterpriseEligibilityUrl, profileUrl, merchantInfoUrl, promotionsUrl, cardActivationUrl, travelNotificationUrl } from "./endpoints.js";
const rewardsBalanceCacheKey = ({
  accountId,
  accountIdType,
  lang
}) => [rewardsBalanceUrl, { accountId, accountIdType, lang }];
const rewardsCertificateCacheKey = ({
  accountId,
  certificateRequestType,
  accountIdType,
  certificateNumber
}) => [
  rewardsCertificateUrl,
  { accountId, certificateRequestType, accountIdType, certificateNumber }
];
const creditHealthCacheKey = ({
  accountId,
  accountIdType,
  lang
}) => [creditHealthUrl, { accountId, accountIdType, lang }];
const statementsCacheKey = ({
  accountId,
  accountIdType
}) => [statementsUrl, { accountId, accountIdType }];
const statementsEnrollmentCacheKey = ({
  accountId,
  accountIdType
}) => [statementsEnrollmentUrl, { accountId, accountIdType }];
const accountActivityCacheKey = ({
  accountId,
  accountIdType
}) => [accountActivityUrl, { accountId, accountIdType }];
const autoRegisterCacheKey = (props) => [autoRegisterUrl, props];
const paymentQueryCacheKey = ({
  accountId,
  accountIdType,
  page,
  size
}) => [paymentQueryUrl, { accountId, accountIdType, page, size }];
const accountSummaryV2CacheKey = ({
  accountId,
  accountIdType
}) => [accountSummaryV2Url, { accountId, accountIdType }];
const creditAccountsCacheKey = () => [creditAccountsUrl];
const autopayStatusCacheKey = ({
  accountId,
  accountIdType
}) => [autopayStatusUrl, { accountId, accountIdType }];
const autopayEligibilityCacheKey = ({
  accountId,
  accountIdType,
  requestor
}) => [autopayEligibilityUrl, { accountId, accountIdType, requestor }];
const payoffQuoteCacheKey = ({
  accountId,
  accountIdType
}) => [payoffQuoteUrl, { accountId, accountIdType }];
const paymentMethodsCacheKey = ({
  accountId,
  accountIdType
}) => [paymentMethodsUrl, { accountId, accountIdType }];
const settlementEligibilityCacheKey = ({
  accountId,
  accountIdType
}) => [settlementEligibilityUrl, { accountId, accountIdType }];
const accountFeaturesCacheKey = ({
  accountId,
  accountIdType
}) => [accountFeaturesUrl, { accountId, accountIdType }];
const paymentEnterpriseEligibilityCacheKey = ({
  accountId,
  accountIdType
}) => [paymentEnterpriseEligibilityUrl, { accountId, accountIdType }];
const alternatePaymentMethodsCacheKey = ({
  accountId,
  accountIdType
}) => ["alternatePaymentMethods", { accountId, accountIdType }];
const profileDetailsCacheKey = ({
  accountId,
  accountIdType
}) => [`${profileUrl}-details`, { accountId, accountIdType }];
const profileScopeCacheKey = ({
  accountId,
  accountIdType
}) => [`${profileUrl}-scope`, { accountId, accountIdType }];
const merchantInfoCacheKey = ({
  merchantId
}) => [merchantInfoUrl, merchantId];
const promotionsCacheKey = ({
  accountId,
  accountIdType
}) => [promotionsUrl, { accountId, accountIdType }];
const cancelPaymentCacheKey = ({
  accountId,
  accountIdType
}) => [paymentQueryUrl, { accountId, accountIdType }];
const cardActivationCacheKey = ({
  accountId,
  accountIdType,
  paymentInstrumentReferenceId
}) => [
  cardActivationUrl,
  { accountId, accountIdType, paymentInstrumentReferenceId }
];
const travelNotificationCacheKey = ({
  accountId,
  accountIdType
}) => [travelNotificationUrl, { accountId, accountIdType }];
export { accountActivityCacheKey, accountFeaturesCacheKey, accountSummaryV2CacheKey, alternatePaymentMethodsCacheKey, autoRegisterCacheKey, autopayEligibilityCacheKey, autopayStatusCacheKey, cancelPaymentCacheKey, cardActivationCacheKey, creditAccountsCacheKey, creditHealthCacheKey, merchantInfoCacheKey, paymentEnterpriseEligibilityCacheKey, paymentMethodsCacheKey, paymentQueryCacheKey, payoffQuoteCacheKey, profileDetailsCacheKey, profileScopeCacheKey, promotionsCacheKey, rewardsBalanceCacheKey, rewardsCertificateCacheKey, settlementEligibilityCacheKey, statementsCacheKey, statementsEnrollmentCacheKey, travelNotificationCacheKey };
//# sourceMappingURL=cacheKeys.js.map
